import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=16e50500&scoped=true&"
import script from "./Principal.vue?vue&type=script&lang=ts&"
export * from "./Principal.vue?vue&type=script&lang=ts&"
import style0 from "./Principal.vue?vue&type=style&index=0&id=16e50500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e50500",
  null
  
)

export default component.exports